import { Component, OnInit } from '@angular/core';
import {  FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-appointment-modal',
  templateUrl: './appointment-modal.component.html',
  styleUrls: ['./appointment-modal.component.scss']
})
export class AppointmentModalComponent implements OnInit {

  appointmentForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AppointmentModalComponent>,
    private fb: FormBuilder,
  ) {
    this.appointmentForm = this.fb.group({
      photoNumber: this.fb.control('',Validators.compose([Validators.required, Validators.pattern('[0-9]*')])),
      date: this.fb.control('',Validators.compose([Validators.required])),
      time: this.fb.control('',Validators.compose([Validators.required])),
      address: this.fb.control('',Validators.compose([Validators.required, Validators.max(254)])),
    });
   }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
